/* <rr-video> — ambient loop: autoplay silencioso sin controles, pero
   perezoso de verdad: el vídeo solo se descarga y arranca al entrar en
   viewport, se pausa al salir, y con prefers-reduced-motion se queda
   en el póster. data-fallback: la copia de Shopify si el original
   (data-src) no carga; data-lite: la copia pequeña con ahorro de datos
   o red lenta (como <rr-talk>). */
(() => {
  if (customElements.get('rr-video')) return;
  const net = navigator.connection || {};
  const lite = net.saveData === true || /2g|3g/.test(net.effectiveType || '');

  class RRVideo extends HTMLElement {
    connectedCallback() {
      const phone = window.matchMedia('(max-width: 767px)').matches;
      // data-mobile-only: el vídeo es solo del móvil (escena con "Video — phones only"); en el
      // ordenador se queda la foto y no se baja nada, tampoco la copia ligera.
      if (this.hasAttribute('data-mobile-only') && !phone) return;
      const mobile = this.dataset.srcMobile && phone;
      this.mobile = !!mobile;
      const liteSrc = mobile ? this.dataset.liteMobile || this.dataset.lite : this.dataset.lite;
      this.src = (lite && liteSrc) || (mobile ? this.dataset.srcMobile : this.dataset.src);
      if (!this.src) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) this.play();
            else this.pause();
          });
        },
        { rootMargin: '200px 0px' }
      );
      io.observe(this);
    }

    disconnectedCallback() {
      this.pause();
    }

    ensureVideo() {
      if (this.video) return this.video;
      const v = document.createElement('video');
      v.src = this.src;
      v.muted = true;
      v.setAttribute('muted', '');
      v.loop = true;
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.controls = false;
      v.disablePictureInPicture = true;
      v.setAttribute('aria-hidden', 'true');
      v.tabIndex = -1;
      v.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;object-fit:cover;z-index:2';
      v.addEventListener('error', () => {
        const fb = (this.mobile && this.dataset.fallbackMobile) || this.dataset.fallback;
        if (!fb || this.fell) return;
        this.fell = true;
        v.src = fb;
        this.play();
      });
      this.appendChild(v);
      this.video = v;
      return v;
    }

    play() {
      const p = this.ensureVideo().play();
      if (p) p.catch(() => {});
    }

    pause() {
      if (this.video) this.video.pause();
    }
  }

  customElements.define('rr-video', RRVideo);
})();
